import { parse } from "iso8601-duration";

export const getMonthsInterval = (billingPeriod: string) => {
  const duration = parse(billingPeriod);

  return (duration.months || 0) + (duration.years || 0) * 12;
};
